import QuizService from "@/service/quiz.service";
import * as fb from '@/plugins/firebase'

export const state = {
	results: [],
	productScores: [],
	quiz: null,
}

export const mutations = {
	setResults(state, results) {
		state.results = results
	},

	setProductScores(state, productScores) {
		state.productScores = productScores
	},

	setQuiz(state, quiz) {
		state.quiz = quiz
	},

}

export const actions = {

	async getResults({commit}, params) {
		commit('setResults', [])
		/*await QuizService.getQuizResults(params).then(async results => {
			commit('setResults', results)
		})*/

		await QuizService.filterQuizResults(params).then(async results => {
			commit('setResults', results)
		})
	},


	async loadProductScores({commit}, params) {
		commit('setProductScores', [])
		await QuizService.loadProductScores(params).then(async productScores => {
			commit('setProductScores', productScores)
		})

	},

	async updateProductScores({commit}, params) {

		await QuizService.updateProductScores(params).then(async productScores => {
			commit('setProductScores', productScores)
		})

	},

	async loadQuiz({commit}, params) {
		let questions = []

		let campaignId = params.campaignId

		await QuizService.getQuiz(campaignId).then(async quiz => {
			if (quiz.questions) {

				let prepareQuestionData = async (question) => {
					question.images = false

					let multipleQuestion = QuizService.isMultipleOptionsQuestion(question)

					question.answer = multipleQuestion ? [] : null

					if (question.answers) {
						await Promise.all(question.answers.map(async answer => {
							if (answer.hasImage) {
								answer.url = await fb.util.downloadImageUrl(quiz.bucketName, 'answers', answer.id, 'jpg')

								if (!question.images) {
									question.images = !!answer.hasImage
								}
							}
							return answer
						}))
					}

					return question
				}
				questions = await Promise.all(quiz.questions.map(prepareQuestionData))
			}

			commit('setQuiz', quiz)

		})

		commit('setQuestions', questions)
	},

}


export default {
	state,
	actions,
	mutations,
};